<!-- Inner Banner -->
<div class="inner-banner inner-bg9">
    <div class="container">
        <div class="inner-title text-center">
            <!-- <h3>Servicios</h3> -->
            <h1 class="display-1 custom-title">Servicios</h1>
            <ul>
                <li>GRUPO INMOBILIARIO PUEBLA</li>
            </ul>
        </div>
    </div>
</div>
<!-- Inner Banner End -->

<!-- Services Area -->
<div class="services-area pt-100 pb-70">
    <div class="container">
        <div class="service-widget-title">
            <div class="section-title text-center">
                <!-- <span>Our Services</span> -->
                <h2>Beneficios al Invertir en Remates Bancarios con Nosotros</h2>
                <p>Invertir en remates bancarios puede ser una buena inversión porque permite adquirir inmuebles por debajo de su precio de mercado.</p>
            </div>
        </div>

        <div class="row pt-45 pb-20">
            <div class="col-lg-3 col-md-6">
                <div class="services-card">
                    <a routerLink="/services-details" class="services-icon"><i class="flaticon-balance"></i></a>
                    <h3>Acceso exclusivo a propiedades</h3>
                    <p>Ofrecemos a nuestros clientes acceso exclusivo a propiedades que aún no han sido listadas en el mercado abierto, con precios significativamente reducidos.</p>
                    <!-- <a routerLink="/services-details" class="services-more"><i class='flaticon-double-right-arrows-angles'></i></a>
                    <div class="services-card-bottom"></div> -->
                </div>
            </div>

            <div class="col-lg-3 col-md-6">
                <div class="services-card">
                    <a routerLink="/services-details" class="services-icon"><i class="flaticon-sort"></i></a>
                    <h3><a routerLink="/services-details">Vericación de legalidad y estado del inmueble </a></h3>
                    <p>Cada propiedad pasa por un exhaustivo proceso de verificación legal y de estado físico antes de ser incluida en nuestro portafolio.</p>
                    <!-- <a routerLink="/services-details" class="services-more"><i class='flaticon-double-right-arrows-angles'></i></a>
                    <div class="services-card-bottom"></div> -->
                </div>
            </div>

            <div class="col-lg-3 col-md-6">
                <div class="services-card">
                    <a routerLink="/services-details" class="services-icon"><i class="flaticon-analytics"></i></a>
                    <h3><a routerLink="/services-details">Asesoria personalizada</a></h3>
                    <p>Aprovecha la experiencia de expertos en bienes raíces para tomar decisiones informadas que maximicen tus retornos y ajusten a tus necesidades específicas.</p>
                    <!-- <a routerLink="/services-details" class="services-more"><i class='flaticon-double-right-arrows-angles'></i></a>
                    <div class="services-card-bottom"></div> -->
                </div>
            </div>

            <div class="col-lg-3 col-md-6">
                <div class="services-card">
                    <a routerLink="/services-details" class="services-icon"><i class="flaticon-chess-pieces"></i></a>
                    <h3><a routerLink="/services-details">Trámites Ágiles y confiables</a></h3>
                    <p>Nos encargamos de toda la documentación y procesos legales necesarios para la compra de propiedades, asegurando que sean rápidos y sin errores.</p>
                    <!-- <a routerLink="/services-details" class="services-more"><i class='flaticon-double-right-arrows-angles'></i></a>
                    <div class="services-card-bottom"></div> -->
                </div>
            </div>

            <!-- <div class="col-lg-4 col-md-6">
                <div class="services-card">
                    <a routerLink="/services-details" class="services-icon"><i class="flaticon-briefcase-1"></i></a>
                    <h3><a routerLink="/services-details">Business Consulting</a></h3>
                    <p>Sed vel risus a sem cursus fermentum. Aliquam a fermentum velit. Sed varius nisl libero, at tempor lectus mollis.</p>
                    <a routerLink="/services-details" class="services-more"><i class='flaticon-double-right-arrows-angles'></i></a>
                    <div class="services-card-bottom"></div>
                </div>
            </div>

            <div class="col-lg-4 col-md-6">
                <div class="services-card">
                    <a routerLink="/services-details" class="services-icon"><i class="flaticon-people"></i></a>
                    <h3><a routerLink="/services-details">Human Resources</a></h3>
                    <p>Sed vel risus a sem cursus fermentum. Aliquam a fermentum velit. Sed varius nisl libero, at tempor lectus mollis.</p>
                    <a routerLink="/services-details" class="services-more"><i class='flaticon-double-right-arrows-angles'></i></a>
                    <div class="services-card-bottom"></div>
                </div>
            </div>

            <div class="col-lg-12 col-md-12">
                <div class="pagination-area">
                    <span class="page-numbers current" aria-current="page">1</span>
                    <a routerLink="/services-1" class="page-numbers">2</a>
                    <a routerLink="/services-1" class="page-numbers">3</a>
                    <a routerLink="/services-1" class="next page-numbers">Next <i class='bx bx-right-arrow-alt'></i></a>
                </div>
            </div> -->
        </div>
    </div>
</div>
<!-- Services Area End -->





<div class="guidelines-area-two">
    <div class="container-fluid">
        <div class="row align-items-center">
            <div class="col-lg-5 col-md-12 pl-0">
                <div class="guidelines-img">
                    <img src="assets/img/banner14.png" alt="Images">
                </div>
            </div>

            <div class="col-lg-7 col-md-12 pr-0">
                <div class="guidelines-content-bg">
                    <div class="guidelines-content-two">
                        <h2>RECUPERACIONES BANCARIAS</h2>
                        <p>Analiza las tendencias residenciales actuales y futuras, y descubre cuál es la propiedad que más se ajusta a tus necesidades. Recibe las mejores recomendaciones de bienes raíces residenciales. Obtén una correcta valuación y asesoría inmobiliaria de inmuebles.

                        <br><br>Accede a atractivas oportunidades de terrenos y propiedades residenciales logrando maximizar rendimientos.</p>
                        <!-- <div class="signature"><img src="assets/img/signature2.png" alt="Images"></div> -->
                        <div class="content">
                            <h3>GRINPU</h3>
                            <!-- <span>Founder & CEO</span> -->
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>







<div class="services-area pt-100 pb-70">
    <div class="container">
        <div class="service-widget-title">
            <div class="section-title text-center">
                <!-- <span>Our Services</span> -->
                <h3>Solicita información, nuestros asesores te brindarán las mejores opciones con la calidez y confianza que soilo <b>GRINPU</b> puede ofrecerte.</h3>
                <!-- <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit . Pellentesque lacinia vitae libero eu suscipit. Morbi porttitor vel risus at urna semper Suspendisse sodales urna erat, suscipit consequat nisl egestas nec.</p> -->
            </div>
        </div>

        <div class="row pt-45 pb-20">
            <div class="col-lg-3 col-md-6">
                <div class="services-card">
                    <a routerLink="/services-details" class="services-icon"><i class="flaticon-balance"></i></a>
                    <h3>Profesionalismo<br><br></h3>
                </div>
            </div>

            <div class="col-lg-3 col-md-6">
                <div class="services-card">
                    <a routerLink="/services-details" class="services-icon"><i class="flaticon-sort"></i></a>
                    <h3>Asesoramiento<br><br></h3>
                </div>
            </div>

            <div class="col-lg-3 col-md-6">
                <div class="services-card">
                    <a routerLink="/services-details" class="services-icon"><i class="flaticon-analytics"></i></a>
                    <h3>Servicio de calidad<br><br></h3>
                </div>
            </div>

            <div class="col-lg-3 col-md-6">
                <div class="services-card">
                    <a routerLink="/services-details" class="services-icon"><i class="flaticon-chess-pieces"></i></a>
                    <h3>Variedad de propiedades</h3>
                </div>
            </div>
        </div>
    </div>
</div>






<!-- Leader Area -->
<!-- <div class="leader-area">
    <div class="container">
        <div class="leader-content">
            <div class="section-title text-center">
                <h2>Expand Your Presence And Be A Leader Of The World</h2>
                <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nulla amet bibendum ante. Vestibulum ante ipsum primis in faucibus orci.</p>
            </div>
        </div>
    </div>
</div> -->
<!-- Leader Area End -->

<!-- Contact Area -->
<!-- <div class="contact-area pb-100">
    <div class="container">
        <div class="contact-area-bg">
            <div class="row">
                <div class="col-lg-6 col-md-12">
                    <div class="contact-form">
                        <div class="section-title text-center">
                            <h2>Consulting Quote</h2>
                            <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Mauris ante nisi, feugiat vel leo eget, dictum.</p>
                        </div>

                        <form id="contactForm">
                            <div class="row">
                                <div class="col-lg-6 col-sm-6">
                                    <div class="form-group">
                                        <input type="text" name="name" id="name" class="form-control" required placeholder="Name">
                                    </div>
                                </div>

                                <div class="col-lg-6 col-sm-6">
                                    <div class="form-group">
                                        <input type="email" name="email" id="email" class="form-control" required placeholder="Email">
                                    </div>
                                </div>

                                <div class="col-lg-6 col-sm-6">
                                    <div class="form-group">
                                        <input type="text" name="phone_number" id="phone_number" required class="form-control" placeholder="Phone">
                                    </div>
                                </div>

                                <div class="col-lg-6 col-sm-6">
                                    <div class="form-group">
                                        <input type="text" name="msg_subject" id="msg_subject" class="form-control" required placeholder="Your Subject">
                                    </div>
                                </div>

                                <div class="col-lg-12 col-md-12">
                                    <div class="form-group">
                                        <textarea name="message" class="form-control" id="message" cols="30" rows="8" required data-error="Write your message"></textarea>
                                    </div>
                                </div>

                                <div class="col-lg-12 col-md-12 text-center">
                                    <button type="submit" class="default-btn">Submit</button>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div> -->
<!-- Contact Area End -->
